import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {useSettings} from '@ui/settings/use-settings';
import {redirect, RouteObject} from 'react-router';

type AccessSettings = {
  show_premium?: unknown;
  expire_trials?: unknown;
  trial_minutes?: unknown;
};

function readPremiumFlag(value: unknown): boolean {
  if (value == null || value === '') {
    return true;
  }
  const normalized = String(value).trim().toLowerCase();
  return (
    normalized === 'on' ||
    normalized === '1' ||
    normalized === 'true' ||
    normalized === 'yes'
  );
}

export function isPremiumUiEnabled(): boolean {
  const settings = getBootstrapData().settings as {access?: AccessSettings};
  return readPremiumFlag(settings.access?.show_premium);
}

export function usePremiumUiEnabled(): boolean {
  const settings = useSettings() as {access?: AccessSettings};
  return readPremiumFlag(settings?.access?.show_premium);
}

export function loginUrl(): string {
  const base = getBootstrapData().settings.html_base_uri ?? '';
  const prefix = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${prefix}/login`;
}

export function goToLogin(): void {
  window.location.assign(loginUrl());
}

function isPremiumPath(path: string): boolean {
  return (
    path === 'pricing' ||
    path === 'billing' ||
    path === 'premium' ||
    path.startsWith('premium/') ||
    path.startsWith('checkout')
  );
}

export function gatePremiumRoute(route: RouteObject): RouteObject {
  if (isPremiumUiEnabled() || !route.path || !isPremiumPath(route.path)) {
    return route;
  }

  return {
    path: route.path,
    loader: () => redirect('/'),
  };
}
